export default function ms_to_fs(velocity_in_ms:number):number {
  return velocity_in_ms * 0.3048;
}
